'use strict';

var mediaService = require('./mediaService');
var usercommService = require('./usercommService');
var util = require('./util');
var identityService = require('./identityService');
var inventoryService = require('./inventoryService');

module.exports = {
    mediaService: mediaService,
    usercommService: usercommService,
    identityService: identityService,
    inventoryService: inventoryService,
    util: util
};